<template>
    <div class="gmf-cform-v2-legal-container" v-if="guidelines.label">
        <Checkbox :modelValue="modelValue" @update:modelValue="$emit('update:modelValue', $event)" />
        <div
            class="gmf-cform-v2-footer-legal"
            :class="{
                'gmf-cform-v2-footer-legal-clickable': !!guidelines.text,
            }"
            v-html="guidelines.label"
            @click.stop.prevent="guidelinesModalOpen = true"
        />
    </div>

    <Modal v-model="guidelinesModalOpen" :stackModals="true" v-if="guidelines.text">
        <div class="gmf-comment-guidelines-modal">
            <div class="gmf-header gmf-mb-4" v-if="guidelines.title" v-text="guidelines.title"></div>
            <div v-html="guidelines.text"></div>
        </div>
    </Modal>
</template>

<style>
.gmf-cform-v2-legal-container {
    display: flex;
    gap: var(--gmf-p-3);
    align-items: center;
}
.gmf-comment-guidelines-modal {
    width: 700px;
    max-width: 100%;
}
.gmf-cform-v2-footer-legal-clickable {
    cursor: pointer;
}
.gmf-cform-v2-footer-legal-clickable:hover {
    text-decoration: underline;
}
</style>

<script>
import state from '@/state';
const t = state.t;

import Modal from '@/components/Modal.vue';
import md from '@/utils/md';
import Checkbox from '@/components/Checkbox.vue';


export default {
    props: {
        commentType: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        Modal,
        Checkbox,
    },
    data () {
        return {
            guidelinesModalOpen: false,
        };
    },
    mounted () {
        if (this.guidelines.label && this.commentType == 'marketplace') {
            // Marketplace posts need manual approval
            this.$emit('update:modelValue', false);
        }
    },
    computed: {
        guidelines () {
            if (! state.merchantConfig.commentForm.showGuidelines) {
                return {};
            }
            const guidelines = {
                label: t('comments.guidelines.' + this.commentType + '.label') || t('comments.guidelines.default.label'),
                title: t('comments.guidelines.' + this.commentType + '.title') || t('comments.guidelines.default.title'),
                text: t('comments.guidelines.' + this.commentType + '.text') || t('comments.guidelines.default.text'),
            };

            if (guidelines.label) {
                guidelines.label = md(guidelines.label.replaceAll('\\n', '\n'));
            }

            if (guidelines.text) {
                guidelines.text = md(guidelines.text.replaceAll('\\n', '\n'));
            }

            return guidelines;
        },
    },
};
</script>